export type UrlEnvironmentType = 'production' | 'staging' | 'development';

export function isDevelopment(environmentType: UrlEnvironmentType): boolean {
  return environmentType === 'development';
}
